import React, { useState, useCallback, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { networkProvider } from "../locales/en";

export const NetworkContext = React.createContext(null);
export const NetworkProvider = ({ children }) => {
  const [online, setOnline] = useState(() => navigator.onLine);

  const setOnlineToTrue = useCallback(() => {
    setOnline(true);
  }, []);

  const setOnlineToFalse = useCallback(() => {
    setOnline(false);
  }, []);

  useEffect(() => {
    window.addEventListener("online", setOnlineToTrue);
    window.addEventListener("offline", setOnlineToFalse);

    return () => {
      window.removeEventListener("online", setOnlineToTrue);
      window.removeEventListener("offline", setOnlineToFalse);
    };
  }, [setOnlineToTrue, setOnlineToFalse]);

  return (
    <NetworkContext.Provider value={{ online }}>
      {children}
    </NetworkContext.Provider>
  );
};

NetworkProvider.propTypes = {
  children: PropTypes.node
};

export const useNetworkCheck = () => {
  const context = useContext(NetworkContext);
  if (!context) {
    throw new Error(networkProvider?.error);
  }
  return context;
};
